import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';


import * as projectApi from '../../lib/api/project';


const [VIEW_ORDER, VIEW_ORDER_SUCCESS, VIEW_ORDER_FAILURE] =
    createRequestActionTypes('project/VIEW_ORDER');
export const viewOrder = createAction(VIEW_ORDER, (id) => id);
const viewOrderSaga = createRequestSaga(VIEW_ORDER, projectApi.getOrderInfoAll);






// function* viewOrderSaga(action) {
//   yield put(startLoading(VIEW_ORDER)); 

//   try {
//   //project정보 가져오기
//   const projectRes = yield call(projectApi.getOrder, action.payload);
//   const orderCountRes = yield call(projectApi.getOrderOrderCount, action.payload);

//   const project = projectRes.data.info;
//   project.cmpStatus = (project.cmpGrade === '0' || project.cmpGrade===null)?'수주':project.cmpStatus;

//   yield put({
//     type: VIEW_ORDER_SUCCESS,
//     payload: {
//       project: project,
//       ordCount: orderCountRes.data.count,
//       ordInfo:orderCountRes.data.list
//     },
//   });

//   //project의 수주 Count 가져오기
// } catch (e) {
//   yield put({
//     type: VIEW_ORDER_FAILURE,
//     payload: e,
//     error: true,
//   });
// }


//   yield put(finishLoading(VIEW_ORDER));
// }


const UNLOAD_ORDER = 'project/UNLOAD_ORDER';
export const unloadOrder = createAction(UNLOAD_ORDER);

const SET_ORDER = 'project/SET_ORDER';
export const setOrder = createAction(SET_ORDER, (project) => project);


export function* orderSaga() {
    yield takeLatest(VIEW_ORDER, viewOrderSaga);
}

const initialState = {
    receiveOrderInf: null,//수주 정보
    billInfList: null,//매입/매출 정보
    billInvList: null,//세금계산서 정보
    approvalList: null,//결재 정보(V1 레거시)
    apprUuid: null,//결재선ID
    // 결재 V2 문서 헤더(COM_APPR_DOC_INF) - 백엔드 getOrderMainInf가 이미 채워 보내는데
    // 리듀서가 그동안 떨어뜨리고 있었다(이슈 #9, 2026-10-21 "결재 내역" 패널이 항상 비어
    // 보이던 원인). null이면 이 수주품의서는 V1(레거시) 결재선이거나 결재 상신 전이다.
    apprDocV2: null,
    message: null,
    error: null,
};

const order = handleActions(
    {
        [VIEW_ORDER_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            apprUuid: data.apprUuid,
            apprDocV2: data.apprDocV2 || null,
            receiveOrderInf: data.receiveOrderInf,
            billInfList: data.billInfList.map((inf) => ({
                id: inf.billUuid,
                billUuid: inf.billUuid,
                prjUuid: inf.prjUuid,
                roUuid: inf.roUuid,
                billDiv: 1,
                partnerUuid: inf.partnerUuid,
                partnerNm: inf.partnerNm,
                billAmt: Number(inf.billAmt),
                billTyp: inf.billTyp,
                issueReq: inf.issueReq,
                issueComp: inf.issueComp,
                collComp: inf.collComp,
                billYn: inf.billYn,
                crtUsr: inf.crtUsr,
                crtNm: inf.crtNm,
                crtDt: inf.crtDt,
                cngUsr: inf.cngUsr,
                cngNm: inf.cngNm,
                cngDt: inf.cngDt,
            })),
            billInvList: data.billInvList.map((inv) => ({
                id: inv.invUuid,
                invUuid: inv.invUuid,
                prjUuid: inv.prjUuid,
                roUuid: inv.roUuid,
                billUuid: inv.billUuid,
                billTyp: inv.billTyp,
                invTyp: inv.invTyp,
                invNo: inv.invNo,
                invYn: inv.invYn,
                invAmt: Number(inv.invAmt),
                reqPlanDt: inv.reqPlanDt,
                reqPlanUsr: inv.reqPlanUsr,
                reqPlanTxt: inv.reqPlanTxt,
                reqPlanYn: inv.reqPlanYn,
                reqCompDt: inv.reqCompDt,
                reqCompYn: inv.reqCompYn,
                reqCompUsr: inv.reqCompUsr,
                reqCompTxt: inv.reqCompTxt,
                procPlanDt: inv.procPlanDt,
                procPlanYn: inv.procPlanYn,
                procPlanUsr: inv.procPlanUsr,
                procCompDt: inv.procCompDt,
                procCompYn: inv.procCompYn,
                procTyp: inv.procTyp,
                rsltCompDt: inv.rsltCompDt,
                rsltCompYn: inv.rsltCompYn,
                crtUsr: inv.crtUsr,
                crtNm: inv.crtNm,
                crtDt: inv.crtDt,
                cngUsr: inv.cngUsr,
                cngNm: inv.cngNm,
                cngDt: inv.cngDt,
            })),
            approvalList: data.approvalList.map((doc) => ({
                id: doc.docuUuid,
                apprUuid: doc.apprUuid,
                docuUuid: doc.docuUuid,
                docyTyp: doc.docyTyp,
                docuStep: doc.docuStep,
                docuUsr: doc.docuUsr,
                docuUsrNm: doc.docuUsrNm,
                docuUsrProfile: doc.docuUsrProfile,
                docuUsrDptNm: doc.docuUsrDptNm,
                docuUsrGradeNm: doc.docuUsrGradeNm,
                docuYn: doc.docuYn,
                docuDt: doc.docuDt,
                docuTxt: doc.docuTxt,
                docuCd: doc.docuCd,
                crtUsr: doc.crtUsr,
                crtDt: doc.crtDt,
                cngUsr: doc.cngUsr,
                cngDt: doc.cngDt,
            })),
        }),
        [VIEW_ORDER_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [SET_ORDER]: (state, { payload: data }) => ({
            ...state, apprUuid: data.apprUuid,
            receiveOrderInf: data.receiveOrderInf,
            billInfList: data.billInfList.map((inf) => ({
                id: inf.billUuid,
                billUuid: inf.billUuid,
                prjUuid: inf.prjUuid,
                roUuid: inf.roUuid,
                billDiv: 1,
                partnerUuid: inf.partnerUuid,
                partnerNm: inf.partnerNm,
                billAmt: Number(inf.billAmt),
                billTyp: inf.billTyp,
                issueReq: inf.issueReq,
                issueComp: inf.issueComp,
                collComp: inf.collComp,
                billYn: inf.billYn,
                crtUsr: inf.crtUsr,
                crtNm: inf.crtNm,
                crtDt: inf.crtDt,
                cngUsr: inf.cngUsr,
                cngNm: inf.cngNm,
                cngDt: inf.cngDt,
            })),
            billInvList: data.billInvList.map((inv) => ({
                id: inv.invUuid,
                invUuid: inv.invUuid,
                prjUuid: inv.prjUuid,
                roUuid: inv.roUuid,
                billUuid: inv.billUuid,
                invNo: inv.invNo,
                invYn: inv.invYn,
                invAmt: Number(inv.invAmt),
                reqPlanDt: inv.reqPlanDt,
                reqPlanUsr: inv.reqPlanUsr,
                reqPlanTxt: inv.reqPlanTxt,
                reqPlanYn: inv.reqPlanYn,
                reqCompDt: inv.reqCompDt,
                reqCompYn: inv.reqCompYn,
                reqCompUsr: inv.reqCompUsr,
                reqCompTxt: inv.reqCompTxt,
                procPlanDt: inv.procPlanDt,
                procPlanYn: inv.procPlanYn,
                procPlanUsr: inv.procPlanUsr,
                procCompDt: inv.procCompDt,
                procCompYn: inv.procCompYn,
                procTyp: inv.procTyp,
                rsltCompDt: inv.rsltCompDt,
                rsltCompYn: inv.rsltCompYn,
                crtUsr: inv.crtUsr,
                crtNm: inv.crtNm,
                crtDt: inv.crtDt,
                cngUsr: inv.cngUsr,
                cngNm: inv.cngNm,
                cngDt: inv.cngDt,
            })),
            approvalList: data.approvalList.map((doc) => ({
                id: doc.docuUuid,
                apprUuid: doc.apprUuid,
                docuUuid: doc.docuUuid,
                docyTyp: doc.docyTyp,
                docuStep: doc.docuStep,
                docuUsr: doc.docuUsr,
                docuUsrNm: doc.docuUsrNm,
                docuUsrProfile: doc.docuUsrProfile,
                docuUsrDptNm: doc.docuUsrDptNm,
                docuUsrGradeNm: doc.docuUsrGradeNm,
                docuYn: doc.docuYn,
                docuDt: doc.docuDt,
                docuTxt: doc.docuTxt,
                docuCd: doc.docuCd,
                crtUsr: doc.crtUsr,
                crtDt: doc.crtDt,
                cngUsr: doc.cngUsr,
                cngDt: doc.cngDt,
            })),
        }),
        [UNLOAD_ORDER]: () => initialState,
    },
    initialState,
);

export default order;
